import React from "react";
import PrivacyPolicy from "../../components/client-side/policies/PrivacyPolicy";

const PrivacyPolicyPage = () => {
  return (
    <main className="min-h-screen bg-background text-text transition-colors duration-300">
      <PrivacyPolicy />
    </main>
  );
};

export default PrivacyPolicyPage;
